import { render, staticRenderFns } from "./gold-record.vue?vue&type=template&id=3cd4e3a0&scoped=true&"
import script from "./gold-record.vue?vue&type=script&lang=js&"
export * from "./gold-record.vue?vue&type=script&lang=js&"
import style0 from "./gold-record.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./gold-record.vue?vue&type=style&index=1&id=3cd4e3a0&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd4e3a0",
  null
  
)

export default component.exports